import { HStack, IconButton, useColorModeValue } from "@chakra-ui/react";
import { useState } from "react";
import { AiFillHome, AiFillFire, AiFillShopping } from "react-icons/ai";
import { MdMail } from "react-icons/md";
import { FaUserGraduate } from "react-icons/fa";

import { Link } from "react-scroll";
import { useNav } from "../context/NavContext";

const NavSmall = () => {
  const Links = [
    {
      name: AiFillHome,
      link: "home",
    },
    {
      name: FaUserGraduate,
      link: "about",
    },
    {
      name: AiFillShopping,
      link: "projects",
    },
    {
      name: AiFillFire,
      link: "skills",
    },
    {
      name: MdMail,
      link: "contact",
    },
  ];
  const { activeSection, setActiveSection, manualClick } = useNav();

  const bg = useColorModeValue("#e53e3e", "linear(to-b, #ffdda1, #b07844)");
  const buttonClor = useColorModeValue("white", "#312e2e");
  const selected = useColorModeValue("#e53e3e", "#a2670a");

  return (
    <HStack
      zIndex={999}
      display={{ base: "-webkit-inline-flex", lg: "none" }}
      bg={bg}
      bgGradient={bg} // FAF5FF // FFF5F5 // #FFF5F7 #EBF8FF
      style={{ position: "fixed", bottom: 0, left: 0, right: 10 }}
      alignSelf="center"
      p="6px 5%"
      borderRadius={"25px 25px 0px 0px"}
      w="100%"
      h="54px"
      spacing="7"
      justifyContent="space-between"
    >
      {Links.map((el, i) => {
        const isActive = activeSection === el.link;

        return (
          <Link
            onClick={() => {
              manualClick.current = true;
              setActiveSection(el.link);
              setTimeout(() => {
                manualClick.current = false;
              }, 400);
            }}
            key={el.name}
            to={el.link}
            smooth={true}
            offset={-50}
            duration={400}
            end
          >
            <IconButton
              fontSize={isActive ? "3xl" : "2xl"}
              bg={isActive ? "whiteAlpha.900" : "none"}
              borderTop={isActive ? "5px solid" : "none"}
              color={isActive ? selected : buttonClor}
              variant={isActive ? "outline" : "solid"}
              borderRadius={"50px 50px 50px 50px"}
              h={isActive ? "55px" : "none"}
              position={isActive ? "relative" : "unset"}
              top="-2"
              icon={<el.name />}
            />
          </Link>
        );
      })}
    </HStack>
  );
};

export default NavSmall;
